// 从页面已有插槽中提取名称，避免为配置面板重复维护标题。
export function getSlotLabel(vnodes = []) {
  const nodes = Array.isArray(vnodes) ? vnodes : [vnodes]

  for (const vnode of nodes) {
    const text = typeof vnode?.text === 'string' ? vnode.text.trim() : ''
    if (text) return text.replace(/[：:]$/, '')

    const children = vnode?.children || vnode?.componentOptions?.children
    const childText = children ? getSlotLabel(children) : ''
    if (childText) return childText
  }

  return ''
}

// 忽略已删除或重复的字段，并将新增字段按原配置顺序补到末尾。
export function orderQueryFields(fields, order = []) {
  const remaining = new Map(fields.map((field) => [field.prop, field]))
  const ordered = []

  for (const prop of order) {
    if (!remaining.has(prop)) continue
    ordered.push(remaining.get(prop))
    remaining.delete(prop)
  }

  return ordered.concat([...remaining.values()])
}

// 空 label 项作为前一个条件的附属输入，显隐和排序均按组处理。
export function getQueryFieldGroups(items) {
  const groups = []

  for (const item of items) {
    if (item.label === '' && groups.length) {
      groups[groups.length - 1].items.push(item)
    } else {
      groups.push({ prop: item.prop, items: [item] })
    }
  }

  return groups
}

// 复用 agel-form 的必填规则，包含动态 required、字段 rules 和表单级 rules。
export function isQueryFieldRequired(item, data, rules = {}) {
  const required =
    typeof item.required === 'function' ? item.required(data) : item.required
  return (
    required ||
    []
      .concat(item.rules || [], rules?.[item.prop] || [])
      .some((rule) => rule.required)
  )
}
